import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectUserTheme } from 'containers/App/selectors'
import selectCustomers from 'containers/Customers/selectors'
const DEFAULT_THEME = 'light'

export const defaultBackgroundLight = `linear-gradient(
  115deg,
  rgb(41, 56, 150) 50%,
  rgb(53, 171, 226) 100%
)`
export const defaultBackgroundDark = `linear-gradient(
  115deg,
  rgb(34, 40, 62) 70%,
  rgb(41, 56, 150) 100%
)`

export const defaultTextLight = '#ffffff'
export const defaultTextDark = '#ffffff'

const useSetThemeToBody = () => {
  const theme = useSelector(selectUserTheme)
  const { customerCode } = useParams()
  const customer = useSelector(selectCustomers)
  const currentCustomer =
    customer.size === 1
      ? customer.first()
      : customer?.find((c) => c.get('code') === customerCode)
  const backgroundColor = currentCustomer?.get('customNavbarBackgroundColor')
  const textColor = currentCustomer?.get('customNavbarColor')
  const logo = currentCustomer?.get('customLogoUrl')

  useEffect(() => {
    document.body.classList.remove('light')
    document.body.classList.remove('dark')
    document.body.classList.add(theme || DEFAULT_THEME)
  }, [theme])

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--custom-background',
      backgroundColor ||
        (theme === 'dark' ? defaultBackgroundDark : defaultBackgroundLight)
    )
    document.documentElement.style.setProperty(
      '--custom-text',
      textColor || (theme === 'dark' ? defaultTextDark : defaultTextLight)
    )
    document.documentElement.style.setProperty('--custom-logo', logo)
  }, [backgroundColor, textColor, customerCode, theme, logo])
}

export default useSetThemeToBody
